export default "__VITE_ASSET__DfGW9soA__"